import { render, staticRenderFns } from "./CustomerInfoParamsSection.vue?vue&type=template&id=42f98d72&scoped=true"
import script from "./CustomerInfoParamsSection.vue?vue&type=script&lang=js"
export * from "./CustomerInfoParamsSection.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoParamsSection.vue?vue&type=style&index=0&id=42f98d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f98d72",
  null
  
)

export default component.exports